import { Component } from 'react';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {NavLink} from 'react-router-dom';
import SingleMessage from '../../Messages/View';
import EmptyMessage from '../../Messages/EmptyMessage';
import {setMessageRead} from '../../../redux/actions/messagesAction';
import {uploadImage} from '../../../redux/actions/addressAction';
import AddressesReports from '../AddressesReports'
import EmptyReports from '../EmptyReports'
import RaisedButton from 'material-ui/RaisedButton';
import BuildingImage from '../BuildingImage';
import _ from 'lodash';

class ViewAddress extends Component {
    constructor(props) {
        super(props);

        this.state = {
            address : false,
            currentTab: 'address_data',
            visibleMessage: false,
            messagesCollapsed: true,
            urgentMessagesCollapsed: true,
            popupOpened: false,
            addressImage: false
        }


        this._mapMessages = this._mapMessages.bind(this);
        this._mapUrgentMessages = this._mapUrgentMessages.bind(this);
        this._renderSidebar = this._renderSidebar.bind(this);
        this._getMessages = this._getMessages.bind(this);
        this._showDetails = this._showDetails.bind(this);
        this.toggleMessageCollapse = this.toggleMessageCollapse.bind(this);
        this._renderMessagesIfNotEmpty = this._renderMessagesIfNotEmpty.bind(this);
        this._renderUrgentMessagesIfNotEmpty = this._renderUrgentMessagesIfNotEmpty.bind(this);
        this._showUrgentDetails = this._showUrgentDetails.bind(this);
        this._openFilePopup = this._openFilePopup.bind(this);
        this._onChangeFile = this._onChangeFile.bind(this);
        this._handleFileUpload = this._handleFileUpload.bind(this);
    }



    toggleMessageCollapse() {
        var isCollapsed = this.state.messagesCollapsed;
        if(isCollapsed) {
            this.setState({
                messagesCollapsed: false
            })
        } else {

            this.setState({
                messagesCollapsed: true
            })

        }
    }

    _difference(object, base) {
        function changes(object, base) {
            return _.transform(object, function(result, value, key) {
                if (!_.isEqual(value, base[key])) {
                    result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
                }
            });
        }
        return changes(object, base);
    }

    componentDidUpdate(prevProps, prevState) {
        //window.Avantage.matchHeight.init();

        const addressId = this.props.match.params.id;
        const address = this.props.addresses.find( address => (address != null ? address.dp_address_id === addressId : false));
        if(address !== this.state.address) {

           if(!_.isEmpty(this._difference(this.state.address, address))) {

                this.setState({
                    address: address
                })
           }

        }

        /**/
    }

    componentDidMount() {
        window.Avantage.matchHeight.init();
        const addressId = this.props.match.params.id;


        if(this.props.addresses) {

            let address = this.props.addresses.find( address => (address != null ? address.dp_address_id === addressId : false ) );
            // let address = _.find(this.props.addresses, function(value, addressId) { return value ? value.dp_address_id == addressId : false; });

            let addressReportTypes = address.reportTypes;
            let showReportTypes = false;
            if(addressReportTypes.length > 0 ) {
                showReportTypes = true;
            }

            const messages = this._getMessages(true);
            let unreadCount = 0;
            if(messages) {
                unreadCount = this._getUnreadCount(messages);
            }

            this.setState({
                address: address,
                showReportTypes,
                unreadMessages: unreadCount
            })
        }

        document.querySelector('title').innerHTML = 'MijnDP - Adres';
    }

    _getMessages(urgent = false) {
        let messages = false;
        if(this.props.match.params.id && this.props.messages.data) {

            let filterable = this.props.messages.data;
            if ( filterable.data ) {
                filterable = filterable.data;
            }

            messages = filterable.filter( message => message.dp_address_id === this.props.match.params.id);
        }

        if(messages) {

            messages = messages.filter( message => message.has_been_read !== "1");
            if(urgent) {
                messages = messages.filter( message => message.is_priority === "1");
            }else{
                messages = messages.filter( message => message.is_priority === "0");
            }
        }

        if(messages.length) {

            return messages;
        } else {
            return false;
        }
    }

      _renderSidebar(is_priority) {
        if(is_priority === '1') {
            return <div className="message__sidebar message__sidebar--priority"></div>
        }else{
            return <div className="message__sidebar"></div>
        }
    }

    handleChange = (value) => {
        this.setState({
            currentTab: value,
        });
    };

    _showDetails(event, messageId) {

        event.preventDefault();

        if(this.props.user.user_profile.is_representative !== "1") {
            this.props.setMessageRead(this.props.clientPath, messageId, this.props.user.user_id, true);
        }

        if(this.state.visibleMessage === messageId) {
            messageId = false;
        }

        this.setState({
            visibleMessage: messageId
        })

    }

    _showUrgentDetails(event, messageId) {

        event.preventDefault();

        if(this.props.user.user_profile.is_representative !== '1') {
            this.props.setMessageRead(this.props.clientPath, messageId, this.props.user.user_id, true);
        }

        if(this.state.visibleUrgentMessage === messageId) {
            messageId = false;
        }

        this.setState({
            visibleUrgentMessage: messageId
        })

    }

    _getUnreadCount(messages) {
        let unreadCount = 0;
        for(let i = 0; i <= messages.length; i++) {
            if(messages[i]) {
               if(messages[i]['has_been_read'] === '0') {
                    unreadCount++;
                }
            }
        }

        return unreadCount;

    }

    _mapMessages(message, key) {

        let messageClass = "message";
        let wrapperClass = "building__message--read";
        if(message.has_been_read === "0") {
            messageClass = messageClass + ' message--unread';
            wrapperClass = "building__message--unread";
        }


        let activeClass = this.state.visibleMessage ? this.state.visibleMessage === message.message_id ? 'single__message--visible' : '' : '';
        return (
            <SingleMessage wrapperClass={wrapperClass} key={key} smaller={true} showDetails={this._showDetails} messageClass={messageClass} message={message} activeClass={activeClass}/>
        )
    }

    _mapUrgentMessages(message, key) {
//        console.log(message);
        let messageClass = "message";
        let wrapperClass = "building__message--read";
        if(message.has_been_read === "0") {
            messageClass = messageClass + ' message--unread';
            wrapperClass = "building__message--unread";
        }

        let activeClass = this.state.visibleMessage ? this.state.visibleMessage === message.message_id ? 'single__message--visible' : '' : '';
         return (
            <SingleMessage wrapperClass={wrapperClass} key={key} smaller={true} showDetails={this._showDetails} messageClass={messageClass} message={message} activeClass={activeClass} />
        )
    }

    _renderEmptyRow() {
        return(
            <li className="single-message single-message--wider">
                {this._renderSidebar(0)}
                <div className="message">
                    <div className="message__inner message__inner--left">
                        <div className="subject">
                            Geen berichten gevonden
                        </div>

                        <div className="content">

                        </div>
                    </div>
                    <div className="message__inner message__inner--right">

                    </div>
                </div>
            </li>
        )
    }

    _renderMessagesIfNotEmpty() {
        if(!this._getMessages() || this._getMessages().length <= 0) {
            return (
                <div className="card" >
                    <div className="card__header">
                        <h1>Ongelezen niet urgente berichten</h1>
                    </div>

                    <div className="card__body">
                        <div className="card__content">
                            <ul className="messages-list">
                                <EmptyMessage smaller={true}/>
                            </ul>
                        </div>
                    </div>
                </div>
            )
        }

        let messagesCollapsed = 'collapsed-in';
        if(this.state.messagesCollapsed === true){
            messagesCollapsed = 'collapsed-out';
        }


        const arraySize = this._getMessages() ? this._getMessages().length : 0;
        const start = 0;
        const end = 3;
        return (
            <div className="card" >
                <div className="card__header">
                    <h1>Ongelezen niet urgente berichten ({_.compact(this._getMessages()).length})</h1>
                    {this._getMessages() ? this._getMessages().length > end ? <span className="show__more show__more--collapsed" onClick={() => this.setState({messagesCollapsed : !this.state.messagesCollapsed})}>{this.state.messagesCollapsed ? <span>Toon meer <i className="fa fa-chevron-down"></i></span> : <span>Toon minder <i className="fa fa-chevron-up"></i></span>}</span> : null : null}
                </div>

                <div className="card__body">
                    <div className="card__content">
                        <ul className="messages-list">
                            {this._getMessages() ? this._getMessages().slice(start, end).map(this._mapMessages) : this._renderEmptyRow()}
                            <span className={"collapsible hidden__list--messages " + messagesCollapsed}>
                                {this._getMessages() ? this._getMessages().slice(end, arraySize).map(this._mapMessages) : this._renderEmptyRow()}
                            </span>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }

    _openFilePopup() {
        this.setState({
            popupOpened: !this.state.popupOpened
        })
    }

    _renderUrgentMessagesIfNotEmpty() {
        if(!this._getMessages(true) || this._getMessages(true).length <= 0) {
            return (
                <div className="card" data-match-height="group-one">
                    <div className="card__header">
                        <h1>Ongelezen urgente berichten</h1>
                    </div>

                    <div className="card__body">
                        <div className="card__content">
                            <ul className="messages-list">
                                <EmptyMessage smaller={true}/>
                            </ul>
                        </div>
                    </div>
                </div>
            )
        }

        let messagesCollapsed = 'collapsed-in';
        if(this.state.urgentMessagesCollapsed === true){
            messagesCollapsed = 'collapsed-out';
        }


        const arraySize = this._getMessages(true) ? this._getMessages(true).length : 0;
        const start = 0;
        const end = 3;
        return (
            <div className="card" data-match-height="group-one">
                <div className="card__header">
                    <h1>Ongelezen urgente berichten ({_.compact(this._getMessages(true)).length})</h1>
                    {this._getMessages(true) ? this._getMessages(true).length > end ? <span className="show__more show__more--collapsed" onClick={() => this.setState({urgentMessagesCollapsed : !this.state.urgentMessagesCollapsed})}>{this.state.urgentMessagesCollapsed ? <span>Toon meer <i className="fa fa-chevron-down"></i></span> : <span>Toon minder <i className="fa fa-chevron-up"></i></span>}</span> : null : null}
                </div>

                <div className="card__body">
                    <div className="card__content">
                        <ul className="messages-list">
                            {this._getMessages(true) ? this._getMessages(true).slice(start, end).map(this._mapUrgentMessages) : this._renderEmptyRow()}
                            <span className={"collapsible hidden__list--messages " + messagesCollapsed}>
                                {this._getMessages(true) ? this._getMessages(true).slice(end, arraySize).map(this._mapUrgentMessages) : this._renderEmptyRow()}
                            </span>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }

    _onChangeFile(e) {
         this.setState({addressImage:e.target.files[0]})
    }

    _handleFileUpload(e) {
    	if(this.state.addressImage) {
    		this.props.uploadImage(this.props.clientPath + '/api/addresses/action/uploadImage', this.state.address.dp_address_id, this.state.addressImage);
	        this.setState({
	            ...this.state,
	            address : {
	                ...this.state.address,
	                address_image : window.URL.createObjectURL(this.state.addressImage)
	            }
	        })
    	}
    	this._openFilePopup();
    }

    render () {
        const reportsCol = 'column column--7--last';
        const addressCol = 'column column--4';
        const messagesCol = "column column--5";
        let popupClass = 'closed';
        if(this.state.popupOpened) {
            popupClass = 'opened';
        }
        return (
            <div>
                <div className={"filePopup " + popupClass}>
                    <div className="popup__backdrop">
                        <div className="popup__holder">
                            <div className="popup__inner">
                                <div className="card">
                                    <div className="card__header">
                                        <h1>Nieuwe afbeelding toevoegen</h1>

                                        <button className="popup__closer" onClick={this._openFilePopup}><i className="fa fa-times"></i></button>
                                    </div>

                                    <div className="card__body">
                                         <form onSubmit={this._handleFileUpload}>

                                            <input  type="file" onChange={this._onChangeFile} />
                                            <RaisedButton style={{marginTop: '15px'}} onClick={() => this._handleFileUpload()} label="Afbeelding wijzigen" primary={true} fullWidth={true}/>
                                          </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className={addressCol}>
                        <div className="card" data-match-height="group-one">
                            <div className="card__header">
                                <h1>{this.state.address.street}</h1>
                                <NavLink to={"/berichten/adres/"+this.props.match.params.id} className="top__right__link">
                                        Alle berichten van dit adres
                                </NavLink>
                            </div>

                            <div className="card__body">
                                <div className="single__address" >
                                    <BuildingImage id={this.props.match.params.id} openFilePopup={this._openFilePopup}/>

                                    <div className="single__address__content">
                                        <ul className="address__properties">
                                            <li>Straat: {this.state.address.street}</li>
                                            <li>Plaats: {this.state.address.city}</li>
                                            <li>Postcode: {this.state.address.zipcode}</li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="column column--8--last">
                        {this._renderUrgentMessagesIfNotEmpty()}
                    </div>

                    <div className="column column--6--last">
                    </div>
                </div>
                <div className="row">
                    <div className={messagesCol} data-match-height="group-two">
                         {this._renderMessagesIfNotEmpty()}
                    </div>
                    {/*<div className={reportsCol} data-match-height="group-two">
                        {this.state.address.reports ? this.state.address.reports.length ? <AddressesReports /> : null : null}
                        {<EmptyReports/>
                        </div>*/}
                </div>
             </div>
            )
    }
}

function mapStateToProps(state) {
    return {
        addresses: state.AddressReducer.addresses,
        reportTypes: state.reportReducer.reportTypes,
        messages: state.messagesReducer.messages,
        clientPath: state.ClientPathReducer.clientPath,
        user: state.UserReducer,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setMessageRead: (url, messageId, userId, setReadNow) => dispatch(setMessageRead(url,messageId, userId, setReadNow)),
        uploadImage: (url, addressId, imageUri) => dispatch(uploadImage(url, addressId, imageUri))
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps, false, {pure: true})(ViewAddress));



// WEBPACK FOOTER //
// ./src/components/Addresses/View/index.js